module.exports = __webpack_public_path__ + "static/img/1.e0c0855.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/1.png
// module id = VpbD
// module chunks = 0